import React, { useState, useEffect } from 'react';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { format, subDays, startOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';

const COP = (n) => new Intl.NumberFormat('es-CO', { maximumFractionDigits: 3 }).format(Number(n) || 0);
const hoy = format(new Date(), 'yyyy-MM-dd');

export default function MateriaPrima() {
  const [tab, setTab] = useState('recepciones');

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>📦 Materia Prima</h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: 14 }}>Recepción, stock actual y registro de consumo</p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', borderBottom: '2px solid #E5E7EB', marginBottom: 20 }}>
        {[
          { id: 'recepciones', label: '📥 Recepciones' },
          { id: 'stock',       label: '📊 Stock actual' },
          { id: 'consumo',     label: '📉 Registro de consumo' },
          { id: 'catalogo',    label: '🗂️ Catálogo de ítems' },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '10px 22px', border: 'none', cursor: 'pointer', fontSize: 13, background: 'transparent',
            fontWeight: tab === t.id ? 800 : 500,
            color: tab === t.id ? '#1a1a2e' : '#6B7280',
            borderBottom: tab === t.id ? '2px solid #1a1a2e' : '2px solid transparent',
            marginBottom: -2,
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'recepciones' && <TabRecepciones />}
      {tab === 'stock'       && <TabStock />}
      {tab === 'consumo'     && <TabConsumo />}
      {tab === 'catalogo'    && <TabCatalogo />}
    </div>
  );
}

// ── TAB RECEPCIONES ──────────────────────────────────────
function TabRecepciones() {
  const [items, setItems]           = useState([]);
  const [recepciones, setRecepciones] = useState([]);
  const [cargando, setCargando]     = useState(false);
  const [desde, setDesde]           = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
  const [hasta, setHasta]           = useState(hoy);
  const [modal, setModal]           = useState(false);
  const [form, setForm]             = useState({ fecha: hoy, proveedor: '', lote: '', item_id: '', cantidad: '', notas: '' });
  const [guardando, setGuardando]   = useState(false);

  useEffect(() => { API.get('/mp/items').then(r => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => { cargar(); }, [desde, hasta]);

  const cargar = () => {
    setCargando(true);
    API.get('/mp/recepciones', { params: { desde, hasta } })
      .then(r => setRecepciones(r.data))
      .catch(() => toast.error('Error cargando recepciones'))
      .finally(() => setCargando(false));
  };

  const handleGuardar = async () => {
    if (!form.proveedor.trim()) { toast.error('El proveedor es obligatorio'); return; }
    if (!form.item_id) { toast.error('Selecciona un ítem'); return; }
    if (!form.cantidad || parseFloat(form.cantidad) <= 0) { toast.error('Cantidad inválida'); return; }
    setGuardando(true);
    try {
      await API.post('/mp/recepciones', form);
      toast.success('✅ Recepción registrada');
      setModal(false);
      setForm({ fecha: hoy, proveedor: '', lote: '', item_id: '', cantidad: '', notas: '' });
      cargar();
    } catch(e) { toast.error(e.response?.data?.error || 'Error guardando'); }
    finally { setGuardando(false); }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Eliminar este registro? Se revertirá el stock.')) return;
    try {
      await API.delete(`/mp/recepciones/${id}`);
      toast.success('Registro eliminado');
      cargar();
    } catch { toast.error('Error eliminando'); }
  };

  // Agrupar por fecha
  const porFecha = {};
  recepciones.forEach(r => {
    const k = r.fecha.slice(0,10);
    if (!porFecha[k]) porFecha[k] = [];
    porFecha[k].push(r);
  });

  return (
    <div>
      {/* Filtros */}
      <div style={{ background: 'white', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <div style={st.label}>Desde</div>
          <input type="date" value={desde} onChange={e => setDesde(e.target.value)} max={hasta} style={st.input} />
        </div>
        <div>
          <div style={st.label}>Hasta</div>
          <input type="date" value={hasta} onChange={e => setHasta(e.target.value)} max={hoy} style={st.input} />
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {[
            { label: 'Hoy', fn: () => { setDesde(hoy); setHasta(hoy); } },
            { label: 'Este mes', fn: () => { setDesde(format(startOfMonth(new Date()), 'yyyy-MM-dd')); setHasta(hoy); } },
          ].map(a => (
            <button key={a.label} onClick={a.fn} style={{ padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#6B7280' }}>{a.label}</button>
          ))}
        </div>
        <button onClick={() => setModal(true)} style={{ marginLeft: 'auto', padding: '9px 20px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#059669,#047857)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
          ➕ Nueva recepción
        </button>
      </div>

      {/* Lista agrupada por fecha */}
      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
      ) : Object.keys(porFecha).length === 0 ? (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          Sin recepciones en este período
        </div>
      ) : (
        Object.keys(porFecha).sort().reverse().map(fecha => (
          <div key={fecha} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
            <div style={{ background: '#1a1a2e', padding: '10px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800, fontSize: 13 }}>
                📅 {format(new Date(fecha + 'T12:00'), "d 'de' MMMM yyyy", { locale: es })}
              </span>
              <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>{porFecha[fecha].length} ítem(s)</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Ítem', 'Categoría', 'Proveedor', 'Lote', 'Cantidad', 'Registrado por', ''].map(h => (
                    <th key={h} style={{ padding: '9px 14px', textAlign: h === 'Cantidad' ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {porFecha[fecha].map((r, i) => (
                  <tr key={r.id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                    <td style={{ padding: '10px 14px', fontWeight: 600 }}>{r.item_nombre}</td>
                    <td style={{ padding: '10px 14px', color: '#6B7280', fontSize: 12 }}>{r.categoria}</td>
                    <td style={{ padding: '10px 14px', color: '#374151' }}>{r.proveedor}</td>
                    <td style={{ padding: '10px 14px', color: '#6B7280', fontSize: 12 }}>{r.lote || '—'}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700, color: '#059669' }}>
                      {COP(r.cantidad)} {r.item_unidad}
                    </td>
                    <td style={{ padding: '10px 14px', color: '#6B7280', fontSize: 12 }}>{r.registrado_por_nombre}</td>
                    <td style={{ padding: '10px 14px' }}>
                      <button onClick={() => handleEliminar(r.id)}
                        style={{ padding: '4px 10px', border: '1px solid #FCA5A5', borderRadius: 6, background: '#FEF2F2', cursor: 'pointer', fontSize: 11, color: '#DC2626', fontWeight: 600 }}>
                        🗑
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {porFecha[fecha][0]?.notas && (
              <div style={{ padding: '8px 14px', background: '#F9FAFB', fontSize: 12, color: '#6B7280', borderTop: '1px solid #F3F4F6' }}>
                <strong>Notas:</strong> {porFecha[fecha][0].notas}
              </div>
            )}
          </div>
        ))
      )}

      {/* Modal nueva recepción */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: 480, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 20 }}>📥 Nueva recepción de materia prima</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
              <div>
                <div style={st.label}>Fecha de recepción</div>
                <input type="date" value={form.fecha} onChange={e => setForm(f => ({ ...f, fecha: e.target.value }))} max={hoy} style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={st.label}>Proveedor</div>
                <input value={form.proveedor} onChange={e => setForm(f => ({ ...f, proveedor: e.target.value }))} placeholder="Nombre del proveedor" autoFocus style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={st.label}>Ítem / Materia prima</div>
              <select value={form.item_id} onChange={e => setForm(f => ({ ...f, item_id: e.target.value }))} style={{ ...st.input, width: '100%', boxSizing: 'border-box' }}>
                <option value="">Seleccionar ítem...</option>
                {Object.entries(
                  items.reduce((g, i) => { (g[i.categoria] = g[i.categoria] || []).push(i); return g; }, {})
                ).map(([cat, its]) => (
                  <optgroup key={cat} label={cat}>
                    {its.map(i => <option key={i.id} value={i.id}>{i.nombre} ({i.unidad})</option>)}
                  </optgroup>
                ))}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
              <div>
                <div style={st.label}>Cantidad</div>
                <input type="number" value={form.cantidad} onChange={e => setForm(f => ({ ...f, cantidad: e.target.value }))} placeholder="0" style={{ ...st.input, width: '100%', boxSizing: 'border-box', fontFamily: 'monospace' }} />
              </div>
              <div>
                <div style={st.label}>Lote (opcional)</div>
                <input value={form.lote} onChange={e => setForm(f => ({ ...f, lote: e.target.value }))} placeholder="Ej: LOT-2026-001" style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: 20 }}>
              <div style={st.label}>Notas (opcional)</div>
              <textarea value={form.notas} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} placeholder="Observaciones adicionales..." rows={2} style={{ ...st.input, width: '100%', boxSizing: 'border-box', resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(false)} style={{ padding: '9px 18px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#6B7280' }}>Cancelar</button>
              <button onClick={handleGuardar} disabled={guardando} style={{ padding: '9px 20px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#059669,#047857)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {guardando ? '⏳ Guardando...' : '✅ Registrar entrada'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── TAB STOCK ────────────────────────────────────────────
function TabStock() {
  const [stock, setStock]     = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    API.get('/mp/stock')
      .then(r => setStock(r.data))
      .catch(() => toast.error('Error cargando stock'))
      .finally(() => setCargando(false));
  }, []);

  const categorias = [...new Set(stock.map(s => s.categoria))].sort();
  const filtrado = stock.filter(s => !busqueda || s.nombre.toLowerCase().includes(busqueda.toLowerCase()) || s.categoria.toLowerCase().includes(busqueda.toLowerCase()));

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input placeholder="🔍 Buscar ítem..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...st.input, flex: 1 }} />
        <div style={{ fontSize: 12, color: '#6B7280', background: '#F9FAFB', padding: '8px 14px', borderRadius: 8 }}>
          {stock.length} ítems · Stock actualizado al último inventario + entradas
        </div>
      </div>

      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
      ) : (
        categorias.map(cat => {
          const its = filtrado.filter(s => s.categoria === cat);
          if (!its.length) return null;
          return (
            <div key={cat} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
              <div style={{ background: '#F3F4F6', padding: '10px 18px', fontWeight: 700, fontSize: 13, color: '#374151', borderBottom: '1px solid #E5E7EB' }}>
                📁 {cat} <span style={{ fontWeight: 400, color: '#9CA3AF', fontSize: 12 }}>({its.length} ítems)</span>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Código', 'Ítem', 'Unidad', 'Stock actual', 'Última actualización'].map(h => (
                      <th key={h} style={{ padding: '9px 14px', textAlign: h === 'Stock actual' ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {its.map((s, i) => (
                    <tr key={s.id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                      <td style={{ padding: '9px 14px', color: '#9CA3AF', fontSize: 12, fontFamily: 'monospace' }}>{s.codigo || '—'}</td>
                      <td style={{ padding: '9px 14px', fontWeight: 600 }}>{s.nombre}</td>
                      <td style={{ padding: '9px 14px', color: '#6B7280' }}>{s.unidad}</td>
                      <td style={{ padding: '9px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, fontSize: 15, color: parseFloat(s.stock) > 0 ? '#059669' : '#EF4444' }}>
                        {COP(s.stock)}
                      </td>
                      <td style={{ padding: '9px 14px', color: '#9CA3AF', fontSize: 12 }}>
                        {s.ultima_actualizacion ? format(new Date(s.ultima_actualizacion), "d MMM yyyy HH:mm", { locale: es }) : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })
      )}
    </div>
  );
}

// ── TAB CONSUMO ──────────────────────────────────────────
function TabConsumo() {
  const [consumo, setConsumo]   = useState([]);
  const [cargando, setCargando] = useState(false);
  const [desde, setDesde]       = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
  const [hasta, setHasta]       = useState(hoy);

  useEffect(() => { cargar(); }, [desde, hasta]);

  const cargar = () => {
    setCargando(true);
    API.get('/mp/consumo', { params: { desde, hasta } })
      .then(r => setConsumo(r.data))
      .catch(() => toast.error('Error cargando consumo'))
      .finally(() => setCargando(false));
  };

  const categorias = [...new Set(consumo.map(c => c.categoria))].sort();

  return (
    <div>
      <div style={{ background: 'white', borderRadius: 14, padding: '14px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <div style={st.label}>Desde</div>
          <input type="date" value={desde} onChange={e => setDesde(e.target.value)} max={hasta} style={st.input} />
        </div>
        <div>
          <div style={st.label}>Hasta</div>
          <input type="date" value={hasta} onChange={e => setHasta(e.target.value)} max={hoy} style={st.input} />
        </div>
        <div style={{ fontSize: 12, color: '#6B7280', background: '#FEF3C7', padding: '8px 14px', borderRadius: 8, alignSelf: 'center' }}>
          💡 El consumo se calcula al hacer inventario físico en Inventario Producción
        </div>
      </div>

      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
      ) : consumo.length === 0 ? (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          Sin registros de consumo en este período
        </div>
      ) : (
        categorias.map(cat => {
          const its = consumo.filter(c => c.categoria === cat);
          return (
            <div key={cat} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
              <div style={{ background: '#F3F4F6', padding: '10px 18px', fontWeight: 700, fontSize: 13, color: '#374151', borderBottom: '1px solid #E5E7EB' }}>
                📁 {cat}
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Fecha inventario', 'Ítem', 'Stock anterior', 'Entradas período', 'Stock esperado', 'Stock real', 'Consumo'].map(h => (
                      <th key={h} style={{ padding: '9px 12px', textAlign: h === 'Ítem' || h === 'Fecha inventario' ? 'left' : 'right', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {its.map((c, i) => (
                    <tr key={c.id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                      <td style={{ padding: '9px 12px', color: '#6B7280', fontSize: 12, whiteSpace: 'nowrap' }}>
                        {format(new Date(c.fecha_inventario + 'T12:00'), "d MMM yyyy", { locale: es })}
                      </td>
                      <td style={{ padding: '9px 12px', fontWeight: 600 }}>{c.item_nombre}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#6B7280' }}>{COP(c.stock_anterior)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#059669' }}>+{COP(c.entradas_periodo)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#374151' }}>{COP(c.stock_esperado)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700 }}>{COP(c.stock_real)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: parseFloat(c.consumo) > 0 ? '#EF4444' : '#059669' }}>
                        {parseFloat(c.consumo) > 0 ? '-' : '+'}{COP(Math.abs(c.consumo))} {c.unidad}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })
      )}
    </div>
  );
}

// ── TAB CATÁLOGO ─────────────────────────────────────────
function TabCatalogo() {
  const [items, setItems]       = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState({ codigo: '', categoria: '', nombre: '', unidad: '' });
  const [guardando, setGuardando] = useState(false);

  const cargar = () => API.get('/mp/items').then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { cargar(); }, []);

  const categorias = [...new Set(items.map(i => i.categoria))].sort();

  const abrirModal = (item) => {
    setForm(item ? { codigo: item.codigo || '', categoria: item.categoria, nombre: item.nombre, unidad: item.unidad } : { codigo: '', categoria: '', nombre: '', unidad: '' });
    setModal(item || 'nuevo');
  };

  const handleGuardar = async () => {
    if (!form.nombre.trim()) { toast.error('El nombre es obligatorio'); return; }
    if (!form.categoria.trim()) { toast.error('La categoría es obligatoria'); return; }
    if (!form.unidad.trim()) { toast.error('La unidad es obligatoria'); return; }
    setGuardando(true);
    try {
      if (modal === 'nuevo') {
        await API.post('/mp/items', form);
        toast.success('✅ Ítem creado');
      } else {
        await API.put(`/mp/items/${modal.id}`, form);
        toast.success('✅ Ítem actualizado');
      }
      setModal(null);
      cargar();
    } catch(e) { toast.error(e.response?.data?.error || 'Error guardando'); }
    finally { setGuardando(false); }
  };

  const handleToggle = async (item) => {
    try {
      await API.put(`/mp/items/${item.id}`, { ...item, activo: !item.activo });
      toast.success(item.activo ? 'Ítem desactivado' : 'Ítem activado');
      cargar();
    } catch { toast.error('Error actualizando'); }
  };

  const filtrado = items.filter(i => !busqueda || i.nombre.toLowerCase().includes(busqueda.toLowerCase()) || i.categoria.toLowerCase().includes(busqueda.toLowerCase()));

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input placeholder="🔍 Buscar ítem..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...st.input, flex: 1 }} />
        <button onClick={() => abrirModal(null)} style={{ padding: '9px 18px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#1a1a2e,#16213e)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap' }}>
          ➕ Nuevo ítem
        </button>
      </div>

      {categorias.map(cat => {
        const its = filtrado.filter(i => i.categoria === cat);
        if (!its.length) return null;
        return (
          <div key={cat} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
            <div style={{ background: '#F3F4F6', padding: '10px 18px', fontWeight: 700, fontSize: 13, color: '#374151', borderBottom: '1px solid #E5E7EB' }}>
              📁 {cat} <span style={{ fontWeight: 400, color: '#9CA3AF', fontSize: 12 }}>({its.length} ítems)</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Código', 'Nombre', 'Unidad', 'Estado', 'Acciones'].map(h => (
                    <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {its.map((item, i) => (
                  <tr key={item.id} style={{ borderTop: '1px solid #F3F4F6', background: !item.activo ? '#FFF7F7' : i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                    <td style={{ padding: '9px 14px', color: '#9CA3AF', fontSize: 12, fontFamily: 'monospace' }}>{item.codigo || '—'}</td>
                    <td style={{ padding: '9px 14px', fontWeight: 600, color: item.activo ? '#111827' : '#9CA3AF' }}>{item.nombre}</td>
                    <td style={{ padding: '9px 14px', color: '#6B7280' }}>{item.unidad}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 700, background: item.activo ? '#D1FAE5' : '#FEE2E2', color: item.activo ? '#065F46' : '#991B1B' }}>
                        {item.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                    <td style={{ padding: '9px 14px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => abrirModal(item)} style={{ padding: '4px 10px', border: '1px solid #E5E7EB', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#374151' }}>✏️ Editar</button>
                        <button onClick={() => handleToggle(item)} style={{ padding: '4px 10px', border: `1px solid ${item.activo ? '#FCA5A5' : '#BBF7D0'}`, borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: item.activo ? '#EF4444' : '#059669' }}>
                          {item.activo ? '⏸ Desactivar' : '▶ Activar'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}

      {/* Modal */}
      {modal !== null && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 20 }}>{modal === 'nuevo' ? '➕ Nuevo ítem' : '✏️ Editar ítem'}</div>
            {[
              { key: 'nombre', label: 'Nombre', placeholder: 'Ej: Azúcar refinada', auto: true },
              { key: 'categoria', label: 'Categoría', placeholder: 'Ej: Ingredientes base' },
              { key: 'unidad', label: 'Unidad de medida', placeholder: 'Ej: kg, lt, Caja' },
              { key: 'codigo', label: 'Código (opcional)', placeholder: 'Ej: ING-001' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 14 }}>
                <div style={st.label}>{f.label}</div>
                <input value={form[f.key]} onChange={e => setForm(fm => ({ ...fm, [f.key]: e.target.value }))}
                  placeholder={f.placeholder} autoFocus={f.auto}
                  style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setModal(null)} style={{ padding: '9px 18px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#6B7280' }}>Cancelar</button>
              <button onClick={handleGuardar} disabled={guardando} style={{ padding: '9px 20px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#1a1a2e,#16213e)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {guardando ? '⏳ Guardando...' : modal === 'nuevo' ? '✅ Crear ítem' : '✅ Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4, display: 'block' },
  input: { padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', background: 'white' },
};
